/* global axios */
import ApiClient from './ApiClient';

class GupshupTemplatesAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  resourcePath(inboxId) {
    return `${this.baseUrl()}/inboxes/${inboxId}/gupshup_templates`;
  }

  list(inboxId) {
    return axios.get(this.resourcePath(inboxId));
  }

  create(inboxId, payload) {
    return axios.post(this.resourcePath(inboxId), {
      gupshup_template: payload,
    });
  }

  update(inboxId, chatwootId, payload) {
    return axios.patch(`${this.resourcePath(inboxId)}/${chatwootId}`, {
      gupshup_template: payload,
    });
  }

  destroy(inboxId, chatwootId) {
    return axios.delete(`${this.resourcePath(inboxId)}/${chatwootId}`);
  }

  /**
   * Creates an Iungo media template (IMAGE / VIDEO / DOCUMENT) via the server:
   * uploads the sample file and submits the template.
   * @param {number} inboxId
   * @param {FormData} formData — fields: sample_media (file), element_name, language_code, category,
   *   vertical, content, footer, example, enable_sample, buttons, template_type, file_type (optional)
   */
  partnerCreateMedia(inboxId, formData) {
    return axios.post(
      `${this.resourcePath(inboxId)}/partner_create_media`,
      formData
    );
  }

  /**
   * Proxies allowlisted Iungo API calls using server-stored credentials.
   * @param {number} inboxId
   * @param {{ partner_request: { method: string, path: string, form?: object } }} payload
   */
  partnerProxy(inboxId, payload) {
    return axios.post(`${this.resourcePath(inboxId)}/partner_proxy`, payload);
  }

  fetchConfiguration(inboxId) {
    return axios.get(
      `${this.baseUrl()}/inboxes/${inboxId}/gupshup_configuration`
    );
  }

  connect(inboxId, payload) {
    return axios.put(
      `${this.baseUrl()}/inboxes/${inboxId}/gupshup_configuration`,
      {
        gupshup_configuration: payload,
      }
    );
  }

  disconnect(inboxId) {
    return axios.delete(
      `${this.baseUrl()}/inboxes/${inboxId}/gupshup_configuration`
    );
  }
}

export default new GupshupTemplatesAPI();
